module.exports = __webpack_public_path__ + "img/resend.f16248d6.svg";